import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
export const fulfillmentTestingCenterAdminAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.FulfillmentTestingCenterDevPortal],
}
